import { APIEndpoints } from "@/data/constants/endpoints";
import { Request } from "@/data/api/utils/network";
import { RequestParams } from "@/data/types";
import { TDashboardRowItem, TDashboardRowPayload } from "@/data/types";

/**
 * Get all dashboardRows with pagination options
 * @param params Request parameters including organization_id, pageNumber, pageSize, etc.
 */
export const getAllDashboardRows = (params: RequestParams) => {
  return Request({
    path: APIEndpoints.DASHBOARD_ROWS.BASE,
    type: "GET",
    params,
  });
};

/**
 * Create a new dashboardRow
 * @param params Request parameters
 * @param payload Create payload
 */
export const createDashboardRow = (
  params: RequestParams,
  payload: TDashboardRowPayload
) => {
  return Request({
    path: APIEndpoints.DASHBOARD_ROWS.BASE,
    type: "POST",
    params,
    body: payload,
  });
};

/**
 * Get a dashboardRow by ID
 * @param dashboardRowId The ID of the dashboardRow to retrieve
 * @param params Request parameters
 */
export const getDashboardRowById = (dashboardRowId: string, params: RequestParams) => {
  return Request({
    path: APIEndpoints.DASHBOARD_ROWS.BY_ID(dashboardRowId),
    type: "GET",
    params,
  });
};

/**
 * Update a dashboardRow by ID
 * @param dashboardRowId The ID of the dashboardRow to update
 * @param params Request parameters
 * @param payload Update payload
 */
export const updateDashboardRow = (
  dashboardRowId: string,
  params: RequestParams,
  payload: Partial<TDashboardRowPayload>
) => {
  return Request({
    path: APIEndpoints.DASHBOARD_ROWS.BY_ID(dashboardRowId),
    type: "PATCH",
    params,
    body: payload,
  });
};

/**
 * Delete a dashboardRow by ID
 * @param dashboardRowId The ID of the dashboardRow to delete
 * @param params Request parameters
 */
export const deleteDashboardRow = (dashboardRowId: string, params: RequestParams) => {
  return Request({
    path: APIEndpoints.DASHBOARD_ROWS.BY_ID(dashboardRowId),
    type: "DELETE",
    params,
  });
};